// removed by extract-text-webpack-plugin
module.exports = {"tabsContainer":"style__tabsContainer___eFr61","tabsContainerItem":"style__tabsContainerItem___3Eahe","tabsContainerItemActive":"style__tabsContainerItemActive___2JXZu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/dropdown-tabs/style.css
// module id = 1303
// module chunks = 0